import { LabelType } from '@hakimo-ui/shared/ui-base';
import { BoltIcon } from '@heroicons/react/24/solid';
import clsx from 'clsx';

interface Props {
  status: string;
  labelType: LabelType;
  iconLabelType?: LabelType;
  small?: boolean;
  iconTitle?: string;
}

export function ListStatusBadge(props: Props) {
  const { status, labelType, iconLabelType, small = false, iconTitle } = props;

  const getColorClass = (type: LabelType) => {
    switch (type) {
      case 'error':
        return 'text-red-500';
      case 'success':
        return 'text-green-600';
      case 'warning':
        return 'text-yellow-600';
      case 'info':
        return 'text-blue-600';
      default:
        return 'text-gray-600';
    }
  };

  const textColorClass = getColorClass(labelType);
  const iconColorClass = getColorClass(iconLabelType || labelType);

  return (
    <div className="flex items-center gap-2">
      <span title={iconTitle}>
        <BoltIcon className={clsx('h-4 w-4', iconColorClass)} />
      </span>
      <span
        className={clsx(
          'font-medium',
          textColorClass,
          small ? 'text-xs' : 'text-sm'
        )}
      >
        {status}
      </span>
    </div>
  );
}

export default ListStatusBadge;
